<template>
  <div class="expert">
    <img class="loading" v-if="loading == true" src="../../../static/common/loading.png" alt="">
    <div class="expertBox" v-for="item in expertData" :key="item.ID">
      <img class="titlePic" :src="item.TitlePic" alt="">
      <ul>
        <li @click="clickExpert(item.ID)">{{item.Title}}</li>
        <li>{{item.Synopsis}}</li>
        <li>
          <p>
            <img src="../../../static/market/news/user.png" alt="">
            <span>{{item.WriterName}}</span>
          </p>
          <p>
            <img src="../../../static/market/news/eyes.png" alt="">
            <span>{{Math.ceil(Math.random()*1000)}}</span>
          </p>
          <p>
            <img src="../../../static/market/news/clock.png" alt="">
            <span>{{item.NewsTime}}</span>
          </p>
        </li>
      </ul>
    </div>
    <button @click="moreExpert">
      <span>更多</span>
      <img src="../../../static/market/more.png" alt="">
    </button>
  </div>
</template>

<script>
  import {expertList} from '../../../api/info'
export default {
  name:'expert',
  data() {
    return{
      expertData:[],
      // 接口参数
      attr:{
        pageIndex:1,
        pageRow:5,
      },
      loading:true,
    }
  },
  created(){
    // 初始化数据
    this.init(this.attr,0);
  },
  methods:{
    // 数据接口
    init(attr,key){
      expertList(attr).then(res=>{
        if(res.ok == 1){
          if(key == 1){
            this.expertData = [...this.expertData,...res.data];
          }else{
            this.expertData = res.data;
            this.loading = false;
          }
        }
      }).catch(err=>{
        console.log(err);
      })
    },
    // 获取更多评论 
    moreExpert(){
      if(this.attr.pageRow == 5){
        this.attr.pageIndex = 1;
        this.attr.pageRow = 10;
        this.init(this.attr,0);
      }else{
        this.attr.pageIndex++;
        this.init(this.attr,1);
      }
    },
    // 跳转到评论详情页
    clickExpert(attr){
      let routeData = this.$router.resolve({ 
        name: "expertDetails",
          query: { 
            id:attr
          }
      });
      window.open(routeData.href, '_blank'); 
    }
  }
}
</script>

<style lang="less" scoped>
  .expert{
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .loading{
      margin: 0 auto 30px;
      width: 50px;
    }
    .expertBox{
      width: 100%;
      height: 205px;
      box-sizing: border-box;
      padding: 0;
      display: flex;
      background-color: #f8f8f8;
      margin-bottom: 40px;
      .titlePic{
        width: 330px;
        height: auto;
      }
      ul{
        width: 70%;
        height: 90%;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: flex-start;
        box-sizing: border-box;
        padding-top: 20px;
        padding-left: 20px;
        li{
          width: 100%;
          p{
            display: flex;
            justify-content: center;
            align-items: center;
            margin-left: 20px;
            img{
              margin-right: 8px;
            }
          }
        }
        li:nth-child(1){
          font-size: 22px;
          font-weight: 540;
          color: #676767;
          cursor: pointer;
        }
        li:nth-child(2){
          color: #666666;
          line-height: 26px;
        }
        li:nth-child(3){
          display: flex;
          justify-content: flex-end;
          align-items: center;
          color: #666666;
        }
      }
    }
    button{
      width: 195px;
      height: 60px;
      border-radius: 5px;
      background-color: #db3d4c;
      border: none;
      margin: 32px auto 110px; 
      cursor: pointer;
      span{
        color: #ffffff;
        margin-right: 5px;
      }
      img{
        width: 10px;
        height: auto;
      }
    }
  }
  @media screen and (max-width: 500px) {
    .expert{
      .loading{
        margin: 0 auto 30px;
        width: 30px;
      }
      .expertBox{
        flex-direction: column;
        justify-content: center;
        align-items: center;
        height: auto;
        margin-bottom: 10px;
        padding: 15px 0;
        .titlePic{
          width: 90%;
          border-radius: 5px;
        }
        ul{
          width: 90%;
          padding-left: 0;
          padding-top: 30px;
          box-sizing: border-box;
          li:nth-child(1){
            font-size: 16px;
            font-weight: 600;
          }
          li:nth-child(2){
            font-size: 13px;
            margin: 20px auto 10px;
          }
          li:nth-child(3){
            p{
              margin-left: 10px;
              span{
                font-size: 12px;
              }
              img{
                width: 18px;
                height: auto;
                margin-right: 3px;
              }
            }
          }
        }
      }
      button{
        width: 125px;
        height: 40px;
        border-radius: 5px;
        background-color: #db3d4c;
        border: none;
        cursor: pointer;
        color: #ffffff;
        margin: 20px 0;
        font-size: 14px;
      }
    }
  }
</style>